import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-crew-management-template',
  templateUrl: './crew-management-template.component.html',
  styleUrls: ['./crew-management-template.component.scss'],
  standalone: false,
})
export class CrewManagementTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;
}
